import React from 'react';
import { useTranslation } from 'react-i18next';
import profileIcon from '@/assets/profile.svg';
import favIcon from '@/assets/heart.svg';
import orderIcon from '@/assets/order.svg';
import listingIcon from '@/assets/listing.svg';
import sellIcon from '@/assets/sell.svg';
import walletIcon from '@/assets/wallet.svg';
import shippingIcon from '@/assets/shipping.svg';
import paymentIcon from '@/assets/payment.svg';
import helpIcon from '@/assets/help.svg';
import logoutIcon from '@/assets/logout.svg';

const ProfileSideMenu = ({ activeMenu, onMenuChange }) => {
  const { t } = useTranslation();

  const menuItems = [
    { 
      id: 'profile', 
      label: t('me.menu.profile'),
      icon: profileIcon
    },
    { 
      id: 'favorites', 
      label: t('me.menu.favorites'),
      icon: favIcon
    },
    { 
      id: 'orders', 
      label: t('me.menu.orders'),
      icon: orderIcon
    },
    { 
      id: 'listings', 
      label: t('me.menu.listings'),
      icon: listingIcon
    },
    { 
      id: 'sales', 
      label: t('me.menu.sales'),
      icon: sellIcon
    },
    { 
      id: 'wallet', 
      label: t('me.menu.wallet'),
      icon: walletIcon
    },
    { 
      id: 'address', 
      label: t('me.menu.address'),
      icon: shippingIcon
    },
    { 
      id: 'payment', 
      label: t('me.menu.payment'),
      icon: paymentIcon
    },
    {
      id: 'feedback',
      label: t('me.menu.feedback'),
      icon: helpIcon
    },
    { 
      id: 'logout', 
      label: t('me.menu.logout'),
      icon: logoutIcon
    }
  ];

  return (
    <div className="bg-white p-2 rounded-lg">
      <nav>
        <ul>
          {menuItems.map(item => (
            <li key={item.id}>
              <button
                className={`w-full text-left flex items-center gap-3 py-4 px-3 rounded-md transition-colors ${
                  activeMenu === item.id 
                    ? 'bg-gray-100 text-primary-600 font-medium' 
                    : 'text-gray-900 hover:bg-gray-50'
                }`}
                onClick={() => onMenuChange(item.id)}
              >
                <img src={item.icon} alt={item.label} className="w-6 h-6" />
                <span className="text-sm">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default ProfileSideMenu; 
